import { createContext, useContext } from 'react';

export const ReportTemplateContext = createContext(null);

export const useReportTemplateContext = () => {
  const context = useContext(ReportTemplateContext);
  if (!context) {
    throw new Error('useReportTemplateContext must be used within a ReportTemplateProvider');
  }
  return context;
};